import { Image, Row } from "antd";
import React from "react";
import { images } from "../../../constants";
import styles from "./styles/loginpage.module.css";
const LoginLogo = () => {
  return (
    <Row align="middle" gutter={5} className={styles.margins}>
      <Image
        preview={false}
        src={images.gensanLogo}
        className={styles.gensanLogo}
      />

      <Image
        src={images.tourismLogo}
        preview={false}
        className={styles.tourismLogo}
      />
    </Row>
  );
};

export default LoginLogo;
